import request from '@/utils/request'

//发消息
export const sendMessagemsg = data => {
  return request({
    url: `/api/business/customerService/sendMessage`,
    method: 'POST',
    data
  })
}
//上传图片附件
export const uploadCsAttachment = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/file/Uploader/annexpic',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
//转人工
export const transferToHuman = data => {
  return request({
    url: `/api/business/customerService/transferToHuman`,
    method: 'POST',
    data
  })
}
//关闭会话
export const closeSession = data => {
  return request({
    url: `/api/business/customerService/closeSession`,
    method: 'POST',
    data
  })
}
//服务评价
export const evaluateService = data => {
  return request({
    url: `/api/business/customerService/evaluateService`,
    method: 'POST',
    data
  })
}
//对话历史记录
export const getUserServiceList = data => {
  return request({
    url: `/api/business/customerService/getUserServiceList`,
    method: 'POST',
    data
  })
}
